import React from 'react';

import { MailOutline } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { gray100 } from '../../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../../constants/Location';

import Header from '../../uiParts/Header';
import CustomHead from '../CustomHead';

const styles = {
  checkIcon: {
    '@media screen and (max-width:600px)': {
      fontSize: '64px'
    },
    fontSize: '80px',
    width: '100%'
  },
  container: {
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 64px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '64px',
      width: '90%'
    },
    height: `calc( 100vh - ${headerHeight} - 96px )`,
    m: `${headerHeight} auto 0`,
    pt: '96px',
    width: '560px'
  },
  text: {
    color: gray100,
    mt: '24px',
    textAlign: 'center'
  },
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: '500',
    mt: '16px',
    textAlign: 'center'
  }
};

const AuthPasswordResetSent: React.FC = () => {
  const location = useLocation();
  const state = location.state as { email: string };

  return (
    <>
      <CustomHead title="パスワード再設定用メール送信 | CMCOS[コムコス]" />
      <Header />
      <Typography component="div" sx={styles.container}>
        <MailOutline sx={styles.checkIcon} />
        <Typography sx={styles.title}>
          パスワード再設定のメールを送信しました
        </Typography>
        <Typography sx={styles.text}>
          パスワード再設定メールを{state.email}宛にお送りしました
          <br />
          お送りしたメールの内容に従ってパスワードを再設定してください。
        </Typography>
      </Typography>
    </>
  );
};

export default AuthPasswordResetSent;
